import { AppState } from "store";
import { ResourceCategoriesFiltersArgs } from "./types";

export const resourceCategoriesFiltersSelector = ({
  filters,
}: AppState): ResourceCategoriesFiltersArgs => {
  return filters.resourceCategories;
};
